import React from "react";

// Mui Styles
import { ThemeProvider } from "@mui/material/styles";
import { StyledPaper } from "@/styles/mui/globalStyles";
import { TableListTheme } from "@/styles/mui/tableListTheme";
import { IconButton } from "@mui/material";
import Chip from "@mui/material/Chip";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
// Navigate
import { useNavigate } from "react-router-dom";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";
import DataTable from "@/components/dataTable";

// Fetch
import { getLandings } from "@/fetch/fetchLanding";

// Moment
import moment from "moment";
import "moment/locale/zh-hk";

// Config
// import { ManingsLandingTableColumn } from "@/config/tableColumnConfig";

const ManningsLandingSettingPage = (props) => {
  const { open, setOpen } = props;

  // Navigate
  const navigate = useNavigate();
  const ManingsLandingTableColumn = [
    {
      field: "name",
      headerName: "優惠名稱",
      flex: 1,
    },
    {
      field: "m18_product_code",
      headerName: "產品SKU",
      flex: 1,
    },
    {
      field: "product_name",
      headerName: "產品名稱",
      flex: 1,
    },
    {
      field: "start_date",
      headerName: "開始日期",
      flex: 1,
      renderCell: (params) => {
        return moment(params.row.start_date).format("YYYY-MM-DD");
      },
    },
    {
      field: "end_date",
      headerName: "結束日期",
      flex: 1,
      renderCell: (params) => {
        return moment(params.row.end_date).format("YYYY-MM-DD");
      },
    },
    {
      field: "time_created",
      headerName: "建立時間",
      flex: 1,
      renderCell: (params) => {
        return moment(params.row.time_created).format("YYYY-MM-DD HH:mm:ss");
      },
    },
    {
      align: "center",
      headerAlign: "center",
      field: "is_active",
      headerName: "狀態",
      renderCell: (params) => {
        return (
          <Chip
            label={params.row.is_active ? "發佈" : "草稿"}
            color={params.row.is_active ? "success" : "error"}
          />
        );
      },
    },
    {
      align: "center",
      headerAlign: "center",
      field: "登記資料",
      renderCell: (params) => {
        return (
          <IconButton
            onClick={(event) => {
              event.stopPropagation();

              navigate(`${params.row.id}/response`);
            }}
          >
            <AppRegistrationIcon />
          </IconButton>
        );
      },
    },
  ];
  const onClickCreate = () => {
    navigate("create");
  };

  // States
  const [landingData, setLandingData] = React.useState([]);
  const [dataTableLoading, setDataTableLoading] = React.useState(false);

  const onCellClick = (data) => {
    navigate(`edit/${data.row.id}`);
  };

  const fetchAll = async () => {
    try {
      setDataTableLoading(true);

      await getLandings().then((data) => {
        if (data && data.results) {
          setLandingData(data.data);
        }
      });
    } catch (error) {
    } finally {
      setDataTableLoading(false);
    }
  };
  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      header="ManningsLandingSettingPage"
      selectedIndex={13}
      open={open}
      setOpen={setOpen}
    >
      <Title
        FunctionOn
        title="萬寧優惠"
        createName="新增萬寧優惠"
        onClickCreate={() => onClickCreate()}
      />
      <StyledPaper page={"yes"}>
        <ThemeProvider theme={TableListTheme}>
          <DataTable
            loading={dataTableLoading}
            rows={landingData}
            columns={ManingsLandingTableColumn}
            pageSize={25}
            onCellClick={(data) => onCellClick(data)}
          />
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default ManningsLandingSettingPage;
